import { css } from '@emotion/react'
import { Tag } from 'bold-ui'
import { green, red } from 'bold-ui/lib/styles/colors'

import { ConsultaSeguimentoPerguntaStatusTagEnum } from '../enums-consultaSeguimento'

interface ConsultaSeguimentoPerguntaStatusTagProps {
  type: ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU | ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU
}

export function ConsultaSeguimentoPerguntaStatusTag(props: Readonly<ConsultaSeguimentoPerguntaStatusTagProps>) {
  const { type } = props

  return (
    <Tag style={styles.tag[type]}>{type === ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU ? 'Passou' : 'Falhou'}</Tag>
  )
}

const styles = {
  tag: {
    [ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU]: css`
      color: ${green.c30};
      background-color: ${green.c80};
    `,
    [ConsultaSeguimentoPerguntaStatusTagEnum.FALHOU]: css`
      color: ${red.c30};
      background-color: ${red.c80};
    `,
  },
}
